import { useRef } from "react";

import type { RefObject } from "react";
import type { MultiSelectHandle } from "@progress/kendo-react-dropdowns";
import type { InputHandle } from "@progress/kendo-react-inputs";

export function useInputFocus<T extends InputHandle | MultiSelectHandle = InputHandle>(): [
  RefObject<T>,
  () => void,
] {
  const htmlElRef = useRef<T>(null);
  const setFocus = () => {
    htmlElRef?.current && htmlElRef.current.focus();
  };

  return [htmlElRef, setFocus];
}
